const PWA_FLAG = 'odeko:pwa-install';

const isStandaloneDisplay = (): boolean =>
  window.matchMedia?.('(display-mode: standalone)').matches === true ||
  (window.navigator as { standalone?: boolean }).standalone === true;

// Record, as early as possible in startup, that this session was launched as an
// installed PWA. The Auth0 login redirect can land the callback in a context
// where the display-mode media query no longer reports standalone, so we persist
// the signal to recover PWA-specific behavior (post-login destination, hiding
// the "use Chrome" nudge) for the rest of the session.
export const recordPwaLaunch = (): void => {
  if (isStandaloneDisplay()) {
    try {
      window.localStorage.setItem(PWA_FLAG, '1');
    } catch {
      // Storage can throw in private modes; the live display check still works.
    }
  }
};

// True when the app is running as an installed PWA — either right now, or earlier
// this session (persisted across the Auth0 redirect).
export const isPwaContext = (): boolean => {
  try {
    if (window.localStorage.getItem(PWA_FLAG) === '1') return true;
  } catch {
    // Ignore and fall back to the live display check.
  }
  return isStandaloneDisplay();
};
